<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Turn on multifactor authentication.</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div>
                <h4>Steps to follow</h4>
                <div style="text-align:left">
                    <span>1. Install any authenticator app on your mobile device.</span><br>   
                    <span>2. Scan this QR code.</span><br>      
                    <span>3. The app will generate a security code.</span><br>      
                    <span>3. Enter the security code from the authenticator app. </span>  
                </div>  
            </div>
            <div style="padding:45px;text-align: -webkit-center;">
                <qr-code v-if="secretCode" v-bind:text="secretCode"></qr-code>
            </div>
            <div style="padding:10px">
                <input class="form-control" placeholder="security code" v-model="deviceCode">
            </div>
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <div class="modal-footer bid">
                <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                <button :disabled="!deviceCode" type="button" class="btn btn-success" @click="verifySoftwareToken()" >SUBMIT</button>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import config from "@/config";
import AWS from 'aws-sdk/global';
import authService from "@/authService";

export default {
    name: 'setUpMfs',
    components :{
       
    },
    data() {
        return {
            loading : false,
            secretCode : null,
            deviceCode : null,
            accessToken : null,
            idtoken : null

        }

    },
    methods:{
        getAssociateSoftwareToken(idtoken,accessToken){
            var self = this;
            const userPoolLoginKey = config.userPoolLoginKey;
            const logins = {};
            logins[userPoolLoginKey] = idtoken;
            AWS.config.region = config.region;
            const cognitoParams = {
                IdentityPoolId: config.IdentityPoolIdFileUpload,
                Logins: logins
            };
            var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider(
                {
                region: "us-east-1",
                credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
                }
            );
            var params = {
                AccessToken: accessToken,
                // Session: 'STRING_VALUE'
            };
            //console.log(cognitoidentityserviceprovider)
            cognitoidentityserviceprovider.associateSoftwareToken(params, function(err, data) {
                if (err){
                    console.log(err, err.stack); // an error occurred
                    self.showSessionReloadPoup()
                }    
                else {
                let domainName = window.location.host !== 'www.drlgroup.app' ? "DRL-DEMO" : "DRL";
                self.secretCode = "otpauth://totp/"+domainName+"?secret="+data.SecretCode;
                }               // successful response
            });
        },
        verifySoftwareToken(){
            var self = this;
            const userPoolLoginKey = config.userPoolLoginKey;
            const logins = {};
            logins[userPoolLoginKey] = this.idtoken;
            AWS.config.region = config.region;
            const cognitoParams = {
                IdentityPoolId: config.IdentityPoolIdFileUpload,
                Logins: logins
            };
            var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider(
                {
                region: "us-east-1",
                credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
                }
            );
            var params = {
                AccessToken: this.accessToken,
                UserCode: this.deviceCode
            };
            console.log(cognitoidentityserviceprovider)
            cognitoidentityserviceprovider.verifySoftwareToken(params, function(err, data) {
                if (err){
                    console.log(err, err.stack); // an error occurred
                    self.showSessionReloadPoup()

                }
                else {
                    console.log(data);
                    self.setUserPreference();
                    self.$emit('close');
                }               // successful response
            });
            
            
    },
    setUserPreference(){
            //  var self = this;
            // const userPoolLoginKey = config.userPoolLoginKey;
            // const logins = {};
            // logins[userPoolLoginKey] = this.idtoken;
            // AWS.config.region = config.region;
            // const cognitoParams = {
            //     IdentityPoolId: config.IdentityPoolIdFileUpload,
            //     Logins: logins
            // };
            // var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider(
            //     {
            //     region: "us-east-1",
            //     credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
            //     }
            // );
            // let userPreference =  {
            //     "AccessToken": this.accessToken,
            //     "SMSMfaSettings": { 
            //         "Enabled": false,
            //         "PreferredMfa": false
            //     },
            //     "SoftwareTokenMfaSettings": { 
            //         "Enabled": true,
            //         "PreferredMfa": true
            //     }
            //     }
            // cognitoidentityserviceprovider.setUserMFAPreference(userPreference, function(err, data) {
            //     if (err){console.log(err, err.stack); // an error occurred
            //         self.showSessionReloadPoup()

            //     }
            //     else {
            //         console.log(data);
            //     }               // successful response
            // });
        let userData = {
            "cognitoSub": authService.getUser().cognitoSub,
            "accessToken": this.accessToken,
            "softwareTokenMfaSettings": {
                "enabled": true,
                "preferredMfa": true
            },
            "sMSMfaSettings": {
              "enabled": false,
              "preferredMfa": false
            }
        }
        const auth = {
            headers: { authorization: this.idtoken ,'org-token' : authService.getOrgToken() }
        };
        this.$http
            .post(
            config.baseUrlBidSide + "/user/mfa-enable ",
            userData,
            auth
            )
            .then(() => {
                this.$alert("MFA is successfully activated.","","success");

            }).catch(() => {
                this.$alert("Something went wrong.","","error");
            });    

    }

    },
    mounted(){
        this.$cognitoAuth.isAuthenticated((session) => {
            this.accessToken = session.accessToken.jwtToken;
            this.idtoken = session.getIdToken().getJwtToken();
            this.getAssociateSoftwareToken(this.idtoken,this.accessToken)
            //console.log(this.accessToken ,  this.idtoken );
        })    
        
    }
};
</script>
<style scoped>

</style>